import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { SingleStepLoading } from '@/pages/Onboarding/components/SingleStepLoading';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PageStyles,
  PageSubtitleStyles,
  PageTitleStyles,
  ContentContainer,
} from './LoaderScreen.styles.ts';

export const LoaderScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'First Loader Screen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="none">
      <IonContent>
        <ContentContainer>
          <LogoWithAppName className="app-logo" withCaption={false} />

          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Create your Own
            <br />
            <PageSubtitleStyles
              variant="inherit"
              color="gradient"
              component="span"
              className="page-subtitle"
            >
              AI Boyfriend
            </PageSubtitleStyles>
          </PageTitleStyles>

          <div className="loading-wrapper">
            <SingleStepLoading
              duration={3.5}
              onComplete={() => handleNextStep()}
            />
          </div>
        </ContentContainer>
      </IonContent>
    </PageStyles>
  );
};
